/**
 * The widget lives inside somebody else's page, so it gets exactly one line of console noise and
 * then stays quiet. A publisher debugging their own site should never have to scroll past us.
 */
let warned = false;

export function warnOnce(message: string, cause?: unknown): void {
  if (warned) return;
  warned = true;
  try {
    console.warn(`[quizee] ${message}`, cause ?? '');
  } catch {
    // A host page that has replaced console is not our problem to solve.
  }
}

/** Test seam. Production code never calls this. */
export function resetWarnings(): void {
  warned = false;
}
